import request from '@/utils/request';
import { iResult } from '@/interface/result';

/**
 * 撤销明细列表
 * @param params 参数
 */
export const getCancelDetialList = (params: any) =>
  request({
    url: '/api/v1/omc/paas/cancel_list',
    method: 'get',
    params,
  });

/**
 * 撤单反馈处理
 * @param params 参数
 */
export const getHandleInfo = (params: any): Promise<any> =>
  request({
    url: '/api/v1/omc/paas/cancel_handle',
    method: 'get',
    params,
  });

/**
 * 获取版本号
 * @param params 参数
 */
export const getVersion = (params: any): Promise<any> =>
  request({
    url: '/api/v1/omc/paas/get_version',
    method: 'get',
    params,
  });
